export interface MegaMenuLink {
  label: string
  href: string
  badge?: 'free'
}

export interface MegaMenuColumn {
  heading: string
  links: readonly MegaMenuLink[]
}

export interface MegaMenuSection {
  id: string
  label: string
  badge?: 'new'
  columns: readonly MegaMenuColumn[]
}

export interface MegaMenuPromo {
  variant: 'insights' | 'post-property'
  title: string
  subtitle?: string
  bullets?: readonly string[]
  cta: { label: string; href: string }
  image?: string
}

export interface MegaMenuConfig {
  id: 'buy' | 'rent' | 'owners'
  sections: readonly MegaMenuSection[]
  promo: MegaMenuPromo
}

/** True when the menu links to at least one real property (not only articles). */
export function hasPropertySections(config: MegaMenuConfig): boolean {
  return config.sections.some((s) => s.id !== 'articles')
}
